<template>
  <a v-if="badge.href" v-bind="attrs" :href="badge.href" target="_blank" rel="noopener noreferrer">
    <img :class="attrs.class" :src="badge.src" :alt="badge.alt" data-test="partner-badge" />
  </a>
  <img v-else v-bind="attrs" :src="badge.src" :alt="badge.alt" data-test="partner-badge" />
</template>

<script lang="ts" setup>
import { useAttrs } from 'vue';

import type { PartnerBadge as PartnerBadgeData } from '@/helpers/partnerBadge/getPartnerBadge';

defineOptions({
  inheritAttrs: false,
});

defineProps<{
  badge: PartnerBadgeData;
}>();

const attrs = useAttrs();
</script>
